<div
  *ngIf="displayMainMenu$ | async"
  class="sidenav-content__wrapper"
  [class.has-customer-select]="hasCustomerSelect$ | async">
  <div class="sidenav-content__top-wrapper">
    <header
      class="sidenav-content__header"
      *ngIf="user$ | async as user">
      <div class="sidenav-content__header-profile-info">
        <h3
          class="sidenav-content__name"
          *ngIf="user.firstName && user.lastName">
          {{ user.firstName }} {{ user.lastName }}
        </h3>
        <span
          class="sidenav-content__email"
          *ngIf="user.email">
          {{ user.email }}

          <ng-container *ngIf="isInSetup$ | async">
            <br />({{
              ("activationPending" | i18n) || "Freischaltung ausstehend"
            }})
          </ng-container>
        </span>
      </div>
    </header>
    <div
      class="sidenav-content__entries-wrapper sidenav-content__entries-wrapper--position-top">
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/dashboard"
        *ngIf="
          !(isInSetup$ | async) && (user$ | async)?.role !== roleEnum.REQUESTER
        "
        [class.active]="(activeRoute$ | async) == 'dashboard'"
        [disabled]="(activeRoute$ | async) == 'dashboard'"
        data-cy="dashboard-nav-item">
        <mat-icon svgIcon="home-outline"></mat-icon>
        <span>{{ ("dashboard" | i18n) || "übersicht" | titlecase }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          (hasJobRequestPermission$ | async) &&
          !(isLoadingRole$ | async) &&
          ((dispoCustomer$ | async)?.enableJobRequestProcess ||
            (user$ | async)?.role === roleEnum.REQUESTER)
        "
        (click)="onItemClick()"
        routerLink="/job-requests"
        [class.active]="(activeRoute$ | async) == 'job-requests'"
        data-cy="job-requests-nav-item">
        <mat-icon svgIcon="job-request"></mat-icon>
        <span>{{
          ("jobRequests" | i18n) || "Dienstanfragen" | titlecase
        }}</span>
        <span
          *ngIf="jobRequestsCount$ | async as jobRequestsCount"
          class="badge"
          data-cy="count-badge">
          {{ jobRequestsCount }}
        </span>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick($event)"
        routerLink="/job-matrix"
        *ngIf="
          !(isInSetup$ | async) &&
          (user$ | async)?.role === roleEnum.REQUESTER &&
          !(isLoadingRole$ | async) &&
          (dispoCustomer$ | async)?.enableRequestOverview &&
          (dispoCustomer$ | async)?.jobMatrixForRequester
        "
        [class.active]="(activeRoute$ | async) == 'job-matrix'"
        [disabled]="(activeRoute$ | async) == 'job-matrix'">
        <mat-icon svgIcon="board-job-shift-grid-matrix"></mat-icon>
        <span>{{ ("jobMatrix" | i18n) || "Dienstmatrix" | titlecase }} </span>
      </button>
      <div
        class="sidenav-content__entries-sub-wrapper"
        *ngIf="
          ((customerHasJobs$ | async) ||
            (user$ | async)?.role === roleEnum.POOL) &&
          (showJobAssignments$ | async)
        ">
        <span class="sub-wrapper-title">{{
          ("jobPool" | i18n) || "Springer-Pool"
        }}</span>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enableCustomerAvailabilityOverview &&
            (dispoCustomer$ | async)?.enableJobs !== false
          "
          (click)="onItemClick()"
          routerLink="/customer/availability-management"
          [class.active]="(activeRoute$ | async) === 'availability-management'"
          [disabled]="(activeRoute$ | async) === 'availability-management'"
          [routerLinkActive]="'active'"
          data-cy="availability-management-nav-item">
          <mat-icon svgIcon="calendar-day-check-availability"></mat-icon>
          <span>{{
            ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase
          }}</span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (poolerHasJobs$ | async) &&
            !(poolerJobsDisabled$ | async) &&
            !(isInSetup$ | async) &&
            !(isLoadingRole$ | async)
          "
          (click)="onItemClick()"
          routerLink="/availability"
          [class.active]="(activeRoute$ | async) == 'availability'"
          [disabled]="(activeRoute$ | async) == 'availability'">
          <mat-icon svgIcon="calendar-day-check-availability"></mat-icon>
          <span>{{
            ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase
          }}</span>
        </button>
        <button
          mat-menu-item
          type="button"
          (click)="onItemClick($event)"
          routerLink="/jobs"
          *ngIf="!(isInSetup$ | async)"
          [class.active]="
            (activeRoute$ | async) == 'jobs' ||
            (activeRoute$ | async) == 'jobs/job'
          "
          [disabled]="(activeRoute$ | async) == 'jobs'"
          data-cy="jobs-nav-item">
          <mat-icon svgIcon="content_paste"></mat-icon>
          <span>{{ ("jobs" | i18n) || "Dienste" | titlecase }} </span>
          <span
            *ngIf="actionRequiredJobsCount$ | async as actionRequiredJobsCount"
            class="badge"
            data-cy="count-badge">
            {{ actionRequiredJobsCount }}
          </span>
        </button>
        <button
          mat-menu-item
          type="button"
          (click)="onItemClick($event)"
          routerLink="/planning-matrix"
          *ngIf="
            !(isInSetup$ | async) &&
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enablePlanningMatrix
          "
          [class.active]="(activeRoute$ | async) == 'planning-matrix'"
          [disabled]="(activeRoute$ | async) == 'planning-matrix'">
          <mat-icon svgIcon="planning-matrix"></mat-icon>
          <span
            >{{ ("planningMatrix" | i18n) || "Planungsmatrix" | titlecase }}
          </span>
        </button>
        <button
          mat-menu-item
          type="button"
          (click)="onItemClick($event)"
          routerLink="/job-matrix"
          *ngIf="
            !(isInSetup$ | async) &&
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enableRequestOverview
          "
          [class.active]="(activeRoute$ | async) == 'job-matrix'"
          [disabled]="(activeRoute$ | async) == 'job-matrix'">
          <mat-icon svgIcon="board-job-shift-grid-matrix"></mat-icon>
          <span>{{ ("jobMatrix" | i18n) || "Dienstmatrix" | titlecase }} </span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enableTranscribeJobList &&
            (showTranscribeJobList$ | async)
          "
          (click)="onItemClick()"
          routerLink="/transcribe-job-list"
          [class.active]="(activeRoute$ | async) == 'transcribe-job-list'"
          [disabled]="(activeRoute$ | async) == 'transcribe-job-list'"
          [routerLinkActive]="'active'"
          data-cy="transcribe-job-list-nav-item">
          <mat-icon svgIcon="checklist_rtl"></mat-icon>
          <span>{{
            ("transferList" | i18n) || "Übertragungsliste" | titlecase
          }}</span>
        </button>
      </div>
      <div
        class="sidenav-content__entries-sub-wrapper"
        *ngIf="
          ((customerHasEmployments$ | async) ||
            (user$ | async)?.role === roleEnum.POOL) &&
          (showEmployment$ | async)
        ">
        <span class="sub-wrapper-title">{{
          ("employmentPool" | i18n) || "Temporär-Pool"
        }}</span>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enableCustomerAvailabilityOverview &&
            (dispoCustomer$ | async)?.enableEmployments
          "
          (click)="onItemClick()"
          routerLink="/temp-work/availability-management"
          [class.active]="
            (activeRoute$ | async) == 'temp-work/availability-management'
          "
          [disabled]="
            (activeRoute$ | async) == 'temp-work/availability-management'
          "
          data-cy="availability-management-nav-item">
          <mat-icon svgIcon="calendar_add_on"></mat-icon>
          <span>{{
            ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase
          }}</span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (poolerHasEmployments$ | async) &&
            !(poolerEmploymentsDisabled$ | async) &&
            !(isInSetup$ | async) &&
            !(isLoadingRole$ | async)
          "
          (click)="onItemClick()"
          routerLink="/temp-work/availability"
          [class.active]="(activeRoute$ | async) == 'temp-work/availability'"
          [disabled]="(activeRoute$ | async) == 'temp-work/availability'">
          <mat-icon svgIcon="calendar_add_on"></mat-icon>
          <span>{{
            ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase
          }}</span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (user$ | async)?.role === roleEnum.DISPO &&
            !(isLoadingRole$ | async) &&
            (dispoCustomer$ | async)?.enableEmployments
          "
          (click)="onItemClick($event)"
          routerLink="/temp-work/employments"
          [class.active]="
            (activeRoute$ | async) == 'temp-work/employments' ||
            (activeRoute$ | async) == 'temp-work/employments/employment'
          "
          [disabled]="(activeRoute$ | async) == 'temp-work/employments'"
          data-cy="employments-nav-item">
          <mat-icon svgIcon="work"></mat-icon>
          <span>{{ ("assignments" | i18n) || "Einsätze" | titlecase }} </span>
          <span
            *ngIf="
              actionRequiredEmploymentsCount$
                | async as actionRequiredEmployments
            "
            class="badge"
            data-cy="count-badge">
            {{ actionRequiredEmployments }}
          </span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
            (user$ | async)?.role === roleEnum.POOL &&
            !(isInSetup$ | async) &&
            !(isLoadingRole$ | async)
          "
          (click)="onItemClick($event)"
          routerLink="/temp-work/pooler-employments"
          [class.active]="
            (activeRoute$ | async) == 'temp-work/pooler-employments'
          "
          [disabled]="(activeRoute$ | async) == 'temp-work/pooler-employments'"
          data-cy="employments-nav-item">
          <mat-icon svgIcon="work"></mat-icon>
          <span>{{ ("assignments" | i18n) || "Einsätze" | titlecase }} </span>
          <span
            *ngIf="
              actionRequiredEmploymentsCount$
                | async as actionRequiredEmployments
            "
            class="badge"
            data-cy="count-badge">
            {{ actionRequiredEmployments }}
          </span>
        </button>
      </div>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          (user$ | async)?.role === roleEnum.DISPO && !(isLoadingRole$ | async)
        "
        (click)="onItemClick()"
        routerLink="/customer/users"
        [class.active]="
          (activeRoute$ | async) == 'users' ||
          (activeRoute$ | async) == 'users/user' ||
          (activeRoute$ | async) == 'users/availability' ||
          (activeRoute$ | async) == 'users/temp-work/availability'
        "
        [disabled]="(activeRoute$ | async) == 'users'"
        data-cy="employees-nav-item">
        <mat-icon svgIcon="group"></mat-icon>
        <span>{{ ("employees" | i18n) || "Mitarbeiter" | titlecase }}</span>
        <span
          *ngIf="actionRequiredUsersCount$ | async as actionRequiredUsersCount"
          class="badge"
          data-cy="count-badge">
          {{ actionRequiredUsersCount }}
        </span>
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="permissionsService.canAccessReports$ | async"
        (click)="onItemClick()"
        routerLink="/reports"
        [class.active]="(activeRoute$ | async) == 'reports'"
        [disabled]="(activeRoute$ | async) == 'reports'"
        [routerLinkActive]="'active'"
        data-cy="reports-nav-item">
        <mat-icon svgIcon="trending_up"></mat-icon>
        <span>{{ ("reports" | i18n) || "Berichte" | titlecase }}</span>
      </button>
    </div>
  </div>
  <div class="sidenav-content__bottom-wrapper">
    <div
      class="sidenav-content__entries-wrapper sidenav-content__entries-wrapper--position-bottom">
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/support"
        [class.active]="(activeRoute$ | async) == 'support'"
        [disabled]="(activeRoute$ | async) == 'support'">
        <mat-icon svgIcon="live_help"></mat-icon>
        <span>{{ ("support" | i18n) || "support" | titlecase }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/profile"
        [class.active]="(activeRoute$ | async) == 'profile'"
        [disabled]="(activeRoute$ | async) == 'profile'">
        <mat-icon svgIcon="profile_icon"></mat-icon>
        <span>{{ ("profile" | i18n) || "profil" | titlecase }}</span>
      </button>
      <button
        *ngIf="hasAdminPermissions$ | async"
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/customer-flags"
        data-cy="admin-nav-item">
        <mat-icon svgIcon="page_info"></mat-icon>
        <span>{{ ("admin" | i18n) || "admin" | titlecase }}</span>
      </button>
      <button
        *ngIf="hasSuperAdminPermissions$ | async"
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/super-admin"
        data-cy="super-admin-nav-item">
        <mat-icon svgIcon="page_info"></mat-icon>
        <span>{{ ("superAdmin" | i18n) || "Super Admin" | titlecase }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="logout()"
        data-cy="logout-button">
        <mat-icon svgIcon="logout"></mat-icon>
        <span>{{ ("logout" | i18n) || "logout" | titlecase }}</span>
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="displayAdminMenu$ | async"
  class="sidenav-content__wrapper">
  <div class="sidenav-content__top-wrapper">
    <header
      class="sidenav-content__header"
      *ngIf="user$ | async as user">
      <div class="sidenav-content__header-profile-info">
        <h3
          class="sidenav-content__name"
          *ngIf="user.firstName && user.lastName">
          {{ user.firstName }} {{ user.lastName }}
        </h3>
        <span
          class="sidenav-content__email"
          *ngIf="user.email">
          {{ user.email }}
        </span>
      </div>
    </header>
    <div
      class="sidenav-content__entries-wrapper sidenav-content__entries-wrapper--position-top">
      <button
        class="back-button"
        mat-button
        type="button"
        (click)="onItemClick()"
        routerLink="/dashboard"
        data-cy="admin-back-button">
        <mat-icon
          class="custom-text-icon-button-icon"
          svgIcon="arrow-left"></mat-icon>
        {{ ("back" | i18n) || "zurück" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/customer-flags"
        [class.active]="(activeRoute$ | async) == 'admin/customer-flags'"
        [disabled]="(activeRoute$ | async) == 'admin/customer-flags'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="page_info"></mat-icon>
        {{ ("customerFlags" | i18n) || "Admin Optionen" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/organisations"
        [class.active]="(activeRoute$ | async) == 'admin/organisations'"
        [disabled]="(activeRoute$ | async) == 'admin/organisations'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="corporate_fare"></mat-icon>
        <span>{{
          ("organisations" | i18n) || "Organisationen" | titlecase
        }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="permissionsService.canAccessReports$ | async"
        (click)="onItemClick()"
        routerLink="/admin/reports"
        [class.active]="(activeRoute$ | async) == 'admin/reports'"
        [disabled]="(activeRoute$ | async) == 'admin/reports'"
        [routerLinkActive]="'active'"
        data-cy="admin-reports-nav-item">
        <mat-icon svgIcon="trending_up"></mat-icon>
        <span>{{ ("reports" | i18n) || "Berichte" | titlecase }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/cancel-reasons"
        [class.active]="(activeRoute$ | async) == 'admin/cancel-reasons'"
        [disabled]="(activeRoute$ | async) == 'admin/cancel-reasons'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="star-rejected-storno-filled"></mat-icon>
        {{ ("cancelReasons" | i18n) || "Storno Gründe" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/certificate-groups"
        [class.active]="(activeRoute$ | async) == 'admin/certificate-groups'"
        [disabled]="(activeRoute$ | async) == 'admin/certificate-groups'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="school"></mat-icon>
        {{
          ("certificateGroups" | i18n) || "Qualifikationsgruppen" | titlecase
        }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/admin/custom-criteria"
        [class.active]="(activeRoute$ | async) == 'admin/custom-criteria'"
        [disabled]="(activeRoute$ | async) == 'admin/custom-criteria'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="filter-alt"></mat-icon>
        {{ "jobSettings" | i18n | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.enablePerigonApi"
        (click)="onItemClick()"
        routerLink="/admin/perigon-mapping"
        [class.active]="(activeRoute$ | async) == 'admin/perigon-mapping'"
        [disabled]="(activeRoute$ | async) == 'admin/perigon-mapping'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="school"></mat-icon>
        {{ ("perigonMapping" | i18n) || "Perigon Zuordnungen" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.enableTariffs"
        (click)="onItemClick()"
        routerLink="/admin/tariffs"
        [class.active]="(activeRoute$ | async) == 'admin/tariffs'"
        [disabled]="(activeRoute$ | async) == 'admin/tariffs'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="currency-usd"></mat-icon>
        {{ ("tariffs" | i18n) || "Tarife" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.enableDefaultValues"
        (click)="onItemClick()"
        routerLink="/admin/job-defaults"
        [class.active]="(activeRoute$ | async) == 'admin/job-defaults'"
        [disabled]="(activeRoute$ | async) == 'admin/job-defaults'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="corporate_fare"></mat-icon>
        {{ ("jobDefaults" | i18n) || "Standard Werte" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.enablePoolerTypes"
        (click)="onItemClick()"
        routerLink="/admin/pooler-types"
        [class.active]="(activeRoute$ | async) == 'admin/pooler-types'"
        [disabled]="(activeRoute$ | async) == 'admin/pooler-types'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="group"></mat-icon>
        {{ ("poolerTypes" | i18n) || "Mitarbeiterarten" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          (dispoCustomer$ | async)?.enableDemandReasons ||
          (dispoCustomer$ | async)?.enableJobRequestProcess
        "
        (click)="onItemClick()"
        routerLink="/admin/demand-reasons"
        [class.active]="(activeRoute$ | async) == 'admin/demand-reasons'"
        [disabled]="(activeRoute$ | async) == 'admin/demand-reasons'"
        [routerLinkActive]="'active'"
        data-cy="demand-reasons-admin-nav-item">
        <mat-icon svgIcon="inbox"></mat-icon>
        {{ ("demandReasons" | i18n) || "Bestellungsgrund" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="
          (dispoCustomer$ | async)?.enableJobRequestProcess &&
          (dispoCustomer$ | async)?.enableJobRequestApproval
        "
        (click)="onItemClick()"
        routerLink="/admin/job-requests"
        [class.active]="(activeRoute$ | async) == 'admin/job-requests'"
        [disabled]="(activeRoute$ | async) == 'admin/job-requests'"
        [routerLinkActive]="'active'"
        data-cy="job-requests-admin-nav-item">
        <mat-icon svgIcon="job-request"></mat-icon>
        {{ ("jobRequestApproval" | i18n) || "Dienstfreigaben" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.enableConditionalTransfers"
        (click)="onItemClick()"
        routerLink="/admin/conditional-transfers"
        [class.active]="(activeRoute$ | async) == 'admin/conditional-transfers'"
        [disabled]="(activeRoute$ | async) == 'admin/conditional-transfers'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
        {{
          ("conditionalTransfers" | i18n) || "Bedingte Transfers" | titlecase
        }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="hasExternalAgencyConnections$ | async"
        (click)="onItemClick()"
        routerLink="/admin/agency-priorities"
        [class.active]="(activeRoute$ | async) == 'admin/agency-priorities'"
        [disabled]="(activeRoute$ | async) == 'admin/agency-priorities'"
        [routerLinkActive]="'active'">
        <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
        {{ ("agencyPriorities" | i18n) || "Agency Priorities" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="customerIsSharingJobPool$ | async"
        (click)="onItemClick()"
        routerLink="/admin/shared-pool-source-settings"
        [class.active]="
          (activeRoute$ | async) == 'admin/shared-pool-source-settings'
        "
        [disabled]="
          (activeRoute$ | async) == 'admin/shared-pool-source-settings'
        "
        [routerLinkActive]="'active'"
        data-cy="shared-pool-nav-item">
        <mat-icon svgIcon="hub"></mat-icon>
        {{ ("sharedPool" | i18n) || "Shared Pool" | titlecase }}
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="displaySuperAdminMenu$ | async"
  class="sidenav-content__wrapper">
  <div class="sidenav-content__top-wrapper">
    <header
      class="sidenav-content__header"
      *ngIf="user$ | async as user">
      <div class="sidenav-content__header-profile-info">
        <h3
          class="sidenav-content__name"
          *ngIf="user.firstName && user.lastName">
          {{ user.firstName }} {{ user.lastName }}
        </h3>
        <span
          class="sidenav-content__email"
          *ngIf="user.email">
          {{ user.email }}
        </span>
      </div>
    </header>
    <div
      class="sidenav-content__entries-wrapper sidenav-content__entries-wrapper--position-top">
      <button
        class="back-button"
        mat-button
        type="button"
        (click)="onItemClick()"
        routerLink="/dashboard"
        data-cy="admin-back-button">
        <mat-icon
          class="custom-text-icon-button-icon"
          svgIcon="arrow-left"></mat-icon>
        {{ ("back" | i18n) || "zurück" | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        (click)="onItemClick()"
        routerLink="/super-admin/settings"
        [class.active]="(activeRoute$ | async) == 'super-admin/settings'"
        [disabled]="(activeRoute$ | async) == 'super-admin/settings'"
        [routerLinkActive]="'active'"
        data-cy="settings-nav-item">
        <mat-icon svgIcon="page_info"></mat-icon>
        {{ "settings" | i18n | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        *ngIf="(dispoCustomer$ | async)?.isDemo"
        (click)="onItemClick()"
        routerLink="/super-admin/demo-settings"
        [class.active]="(activeRoute$ | async) == 'super-admin/demo-settings'"
        [disabled]="(activeRoute$ | async) == 'super-admin/demo-settings'"
        [routerLinkActive]="'active'"
        data-cy="demo-settings-nav-item">
        <mat-icon svgIcon="page_info"></mat-icon>
        {{ "demoSettings" | i18n | titlecase }}
      </button>
    </div>
  </div>
</div>

<!-- include styling -->
<mat-menu></mat-menu>
